/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";

import CircularProgress from '@material-ui/core/CircularProgress';


import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

import { getAllUsers, getMe } from './../../services/users/users'

const useStyles = makeStyles(styles);

export default function Sidebar(props) {

  const classes = useStyles();
  const { color, logo, image, logoText, routes } = props;

  const [role, setRole] = React.useState(null)
  const [routesShow, setRoutesShow] = React.useState(null)

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }

  React.useEffect(() => {
    getUserLogged()
  }, [])

  // const getUserLogged = () => {
  //   const user = JSON.parse(localStorage.getItem('user'));

  //   getAllUsers((users) => {
  //     console.log("USERS:", users)
  //     let currentUser = users.filter(u => u.email === user.data.email)[0];
  //     if (currentUser && currentUser.roleName)
  //       setRole(currentUser.roleName);
  //   });
  // }

  const getUserLogged = () => {
    getMe((currentUser) => {
      if (currentUser && currentUser.roleName)
        setRole(currentUser.roleName);
    });
  }

  const LoadMenu = () => {
    return (
      <div style={{
        width: '100%',
        height: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <CircularProgress size={16} thickness={4} style={{ color: '#FFF' }} />
      </div>
    )
  }

  function ItemLink(prop) {
    //console.log(color)
    var activePro = " ";
    var listItemClasses;
    if (prop.path === "/upgrade-to-pro") {
      activePro = classes.activePro + " ";
      listItemClasses = classNames({
        [" " + classes[color]]: true
      });
    } else {
      listItemClasses = classNames({
        [" " + classes[color]]: activeRoute(prop.layout + prop.path)
      });
    }
    const whiteFontClasses = classNames({
      [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path)
    });

    // console.log("Prop Key", prop.key);

    return <NavLink
      to={prop.layout + prop.path}
      className={activePro + classes.item}
      activeClassName="active"
      // key={prop?.key || Math.round(Math.random()*1000)}
      key={prop.name}
    >
      <ListItem button className={classes.itemLink + listItemClasses}>
        {typeof prop.icon === "string" ? (
          <Icon
            className={classNames(classes.itemIcon, whiteFontClasses, {
              [classes.itemIconRTL]: props.rtlActive
            })}
          >
            {prop.icon}
          </Icon>
        ) : (
          <prop.icon
            className={classNames(classes.itemIcon, whiteFontClasses, {
              [classes.itemIconRTL]: props.rtlActive
            })}
          />
        )}
        <ListItemText
          primary={props.rtlActive ? prop.rtlName : prop.name}
          className={classNames(classes.itemText, whiteFontClasses, {
            [classes.itemTextRTL]: props.rtlActive
          })}
          disableTypography={true}
        />
      </ListItem>
    </NavLink>
  }

  function SideLinks({rotas}) {
    if (role) {

      let newRoutes = rotas

      if (!['Administrador'].includes(role))
        newRoutes = newRoutes.filter(item => !['Usuários', 'Condomínio'].includes(item.name))

      return <List className={classes.list}>
        {
          newRoutes.map((prop, key) => {
            return <ItemLink {...prop} key={key}/>

          })
        }
      </List>
    } else {
      return <List className={classes.list}></List>

    }
  }



  function Brand() {
    return <div className={classes.logo}>
      <a
        href="http://qira.com.br/"
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive
        })}
        target="_blank"
      >
        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
      </a>
    </div>

  }




  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          <Brand />
          <div className={classes.sidebarWrapper}>
            <AdminNavbarLinks />
            <SideLinks rotas={routes}/>
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          <Brand />
          <div className={classes.sidebarWrapper}>
            <SideLinks rotas={routes}/>
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
